import { defineStore } from "pinia";
import { ref, computed } from "vue";

export type AlertDialogVariant = "confirm" | "feedback";

export interface AlertDialogConfig {
  title: string;
  message?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  variant?: AlertDialogVariant;
  event?: string;
  payload?: unknown;
}

export interface AlertDialogEvent {
  event?: string;
  confirmed: boolean;
  payload?: unknown;
}

export const useAlertStore = defineStore("alert", () => {
  const isDialogVisible = ref<boolean>(false);
  const alertMessage = ref<string | undefined>("");
  const alertMessageEmpytList = ref<string | undefined>("");
  const typeAlert = ref<boolean>(false);
  const hasSearchParams = ref<boolean>(false);
  const isLoadingWarningConfirmationBtn = ref<boolean>(false);
  const isAlertDialogVisible = ref<boolean>(false);
  const alertDialogConfig = ref<AlertDialogConfig | null>(null);
  const alertDialogEvent = ref<AlertDialogEvent | null>(null);

  function showDialogAlert(message?: string) {
    isDialogVisible.value = true;
    typeAlert.value = false;
    message === undefined
      ? (alertMessage.value = "Ocorreu um erro. Tente Novamente.")
      : (alertMessage.value = message);
  }

  function showSuccessMessage(message?: string) {
    isDialogVisible.value = true;
    typeAlert.value = true;
    alertMessage.value = message ?? "Operação realizada com sucesso.";
  }

  function hideDialogAlert() {
    isDialogVisible.value = false;
  }

  function showAlertDialog(config: AlertDialogConfig) {
    alertDialogConfig.value = {
      variant: "confirm",
      confirmLabel: "Confirmar",
      cancelLabel: "Fechar",
      ...config,
    };
    alertDialogEvent.value = null;
    isAlertDialogVisible.value = true;
  }

  function hideAlertDialog() {
    isAlertDialogVisible.value = false;
  }

  function emitAlertDialogEvent(confirmed: boolean) {
    alertDialogEvent.value = {
      event: alertDialogConfig.value?.event,
      confirmed,
      payload: alertDialogConfig.value?.payload,
    };
  }

  function clearAlertDialogEvent() {
    alertDialogEvent.value = null;
  }
  function alertNoRegistration(list: object[]) {
    if (list.length === 0 && hasSearchParams.value === true) {
      return (alertMessageEmpytList.value = "! Nenhum dado encontrado.");
    }
    if (list.length === 0) {
      return (alertMessageEmpytList.value = "Listagem vazia.");
    }
    return null;
  }

  const getAlertDialog = computed(() => isDialogVisible.value);
  const getAlertMessage = computed(() => alertMessage.value);
  const getTypeAlert = computed(() => typeAlert.value);
  const warningDialog = ref<boolean>(false);

  return {
    isDialogVisible,
    alertMessage,
    showDialogAlert,
    hideDialogAlert,
    getAlertDialog,
    getAlertMessage,
    showSuccessMessage,
    getTypeAlert,
    hasSearchParams,
    alertNoRegistration,
    alertMessageEmpytList,
    warningDialog,
    isLoadingWarningConfirmationBtn,
    isAlertDialogVisible,
    alertDialogConfig,
    alertDialogEvent,
    showAlertDialog,
    hideAlertDialog,
    emitAlertDialogEvent,
    clearAlertDialogEvent,
  };
});
